/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import {
  SortingState,
  IntegratedSorting,
  DataTypeProvider,
  SearchState,
  IntegratedFiltering,
  PagingState,
  IntegratedPaging,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  TableHeaderRow,
  SearchPanel,
  Toolbar,
  DragDropProvider,
  Table,
  TableColumnReordering,
  TableColumnResizing,
  TableColumnVisibility,
  ColumnChooser,
  PagingPanel,
} from '@devexpress/dx-react-grid-material-ui';
import { getRowId, updateDocNumbers } from '../../common';
import { useLazyQuery } from '@apollo/client';
import { currencyFormatter, timeFormatter } from '../../Shared/colorFormat';
import { SearchTable } from '../../components';
import getTadweenReceipts from '../../graphql/query/getTadweenReceipts';

import { Box, Typography } from '@material-ui/core';
import { TableComponent } from '../../Shared/TableComponent';
import { getColumns } from '../../common/columns';
import { useTemplate } from '../../hooks';
import _ from 'lodash';
import { moneyFormat } from '../common/formater';

const TadweenReceipt = forwardRef((props: any, ref: any) => {
  const { isRTL, words, start, end, drawerWidth } = props;

  const col = getColumns({ isRTL, words });

  const [columns] = useState([
    { name: 'time', title: words?.time },
    { name: 'autoNo', title: words?.no },
    col.customer,
    { name: 'title', title: words?.description },
    { name: 'amount', title: words?.amount },
    { name: 'paymentType', title: isRTL ? 'طريقة الدفع' : 'Pay Type' },
  ]);

  const [tableColumnExtensions]: any = useState([
    { columnName: 'time', width: 120 },
    { columnName: 'autoNo', width: 120 },
    { columnName: col.customer.name, width: 200 },
    { columnName: 'title', width: 400 },
    { columnName: 'amount', width: 120 },
    { columnName: 'paymentType', width: 150 },
  ]);

  const [rows, setRows] = useState([]);
  const [sum, setSum] = useState(0);

  const { tempoptions } = useTemplate();

  const [loadFinances, financeData]: any = useLazyQuery(getTadweenReceipts, {
    fetchPolicy: 'cache-and-network',
  });
  useEffect(() => {
    const variables = {
      start: start ? start.setHours(0, 0, 0, 0) : undefined,
      end: end ? end.setHours(23, 59, 59, 999) : undefined,
    };
    if (start && end) {
      loadFinances({
        variables,
      });
    }
  }, [start, end]);

  useImperativeHandle(ref, () => ({
    refresh() {
      if (financeData?.refetch) {
        financeData.refetch();
      }
    },
  }));

  useEffect(() => {
    if (financeData?.data?.getTadweenReceipts?.data) {
      const { data } = financeData.data.getTadweenReceipts;
      const rdata = updateDocNumbers(data);
      const samount = _.sumBy(rdata, 'amount');
      setSum(samount);
      setRows(rdata);
    }
  }, [financeData]);

  return (
    <>
      <Box
        style={{
          position: 'absolute',
          zIndex: 111,
          left: isRTL ? undefined : drawerWidth + 50,
          right: isRTL ? drawerWidth + 50 : undefined,
          bottom: 50,
          display: 'flex',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <Typography
          style={{
            color: '#333',
            marginLeft: 20,
            marginRight: 20,
          }}
        >
          {isRTL ? ' المجموع ' : ' Total '}: {moneyFormat(sum)}
        </Typography>
      </Box>
      <Grid rows={rows} columns={columns} getRowId={getRowId}>
        <SortingState />
        <SearchState />
        <PagingState defaultCurrentPage={0} defaultPageSize={10} />
        <IntegratedSorting />
        <IntegratedFiltering />
        <IntegratedPaging />
        <DragDropProvider />
        <Table
          messages={{
            noData: isRTL ? 'لا يوجد بيانات' : 'no data',
          }}
          tableComponent={TableComponent}
          rowComponent={(props: any) => (
            <Table.Row {...props} style={{ height: 60 }}></Table.Row>
          )}
          columnExtensions={tableColumnExtensions}
        />

        <TableColumnReordering
          defaultOrder={[
            'time',
            'autoNo',
            col.customer.name,
            'title',
            'amount',
            'paymentType',
          ]}
        />
        <TableColumnResizing defaultColumnWidths={tableColumnExtensions} />

        <TableHeaderRow
          showSortingControls
          titleComponent={({ children }) => {
            return (
              <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                {children}
              </Typography>
            );
          }}
        />
        <TableColumnVisibility
          defaultHiddenColumnNames={[]}
          hiddenColumnNames={[]}
        />
        <DataTypeProvider
          for={['time']}
          formatterComponent={timeFormatter}
        ></DataTypeProvider>
        <DataTypeProvider
          for={['amount']}
          formatterComponent={currencyFormatter}
        ></DataTypeProvider>
        <Toolbar
          rootComponent={(props: any) => (
            <Toolbar.Root
              style={{
                position: 'absolute',
                left: isRTL ? 40 : undefined,
                right: isRTL ? undefined : 40,
                top: 62,
                zIndex: 115,
              }}
              {...props}
            ></Toolbar.Root>
          )}
        />
        <ColumnChooser />
        <PagingPanel
          pageSizes={
            tempoptions?.pageall ? [5, 10, 20, 50, 0] : [5, 10, 20, 50]
          }
        />
        <SearchPanel
          inputComponent={(props: any) => {
            return <SearchTable isRTL={isRTL} {...props}></SearchTable>;
          }}
        />
      </Grid>
    </>
  );
});

export default TadweenReceipt;
